/** @jsx jsx */

import { ComponentProps, ReactNode } from 'react';

import { Icon, Spacer } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import Link from 'app/common/components/Link';

const styleRoot = css`
  align-items: center;
  display: inline-flex;
  line-height: 1.25;
  font-size: 16px;
`;

type Props = {
  ariaLabel?: string;
  /** Link content. */
  children: ReactNode;
  /** Type of arrow */
  iconName?: 'arrowBigRight' | 'arrowOffsite';
  /** Location to link to */
  href?: string;
  /** Link target */
  target?: ComponentProps<typeof Link>['target'];
  /** On click callback. */
  onClick?: () => void;
};

export default function LinkWithArrow({
  ariaLabel,
  children,
  iconName = 'arrowBigRight',
  href,
  onClick,
  target,
}: Props) {
  return (
    <Link ariaLabel={ariaLabel} href={href} onClick={onClick} target={target}>
      <span css={styleRoot}>
        {children}
        <Spacer width={10} />
        <Icon name={iconName} size={15} />
      </span>
    </Link>
  );
}
